// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file shopify/v1/graphql.proto (package shopify.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file shopify/v1/graphql.proto.
 */
export const file_shopify_v1_graphql: GenFile =
    /*@__PURE__*/
    fileDesc(
        'ChhzaG9waWZ5L3YxL2dyYXBocWwucHJvdG8SCnNob3BpZnkudjEiHQoMR3JhcGhxbEVycm9yEg0KBXF1ZXJ5GAEgASgJIisKCVVzZXJFcnJvchINCgVmaWVsZBgBIAMoCRIPCgdtZXNzYWdlGAIgASgJIpABCghQYWdlSW5mbxIZCgxzdGFydF9jdXJzb3IYASABKAlIAIgBARIXCgplbmRfY3Vyc29yGAIgASgJSAGIAQESFQoNaGFzX25leHRfcGFnZRgDIAEoCBIZChFoYXNfcHJldmlvdXNfcGFnZRgEIAEoCEIPCg1fc3RhcnRfY3Vyc29yQg0KC19lbmRfY3Vyc29yIiwKCkV4dGVuc2lvbnMSHgoEY29zdBgBIAEoCzIQLnNob3BpZnkudjEuQ29zdCJ0CgRDb3N0EhwKFHJlcXVlc3RlZF9xdWVyeV9jb3N0GAEgASgDEhkKEWFjdHVhbF9xdWVyeV9jb3N0GAIgASgDEjMKD3Rocm90dGxlX3N0YXR1cxgDIAEoCzIaLnNob3BpZnkudjEuVGhyb3R0bGVTdGF0dXMiXgoOVGhyb3R0bGVTdGF0dXMSGQoRbWF4aW11bV9hdmFpbGFibGUYASABKAESGwoTY3VycmVudGx5X2F2YWlsYWJsZRgCIAEoAxIUCgxyZXN0b3JlX3JhdGUYAyABKAFCbQoOY29tLnNob3BpZnkudjFCDEdyYXBocWxQcm90b1ABWgQuL3BiogIDU1hYqgIKU2hvcGlmeS5WMcoCClNob3BpZnlcVjHiAhZTaG9waWZ5XFYxXEdQQk1ldGFkYXRh6gILU2hvcGlmeTo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message shopify.v1.GraphqlError
 */
export type GraphqlError = Message<'shopify.v1.GraphqlError'> & {
    /**
     * @generated from field: string query = 1;
     */
    query: string;
};

/**
 * Describes the message shopify.v1.GraphqlError.
 * Use `create(GraphqlErrorSchema)` to create a new message.
 */
export const GraphqlErrorSchema: GenMessage<GraphqlError> = /*@__PURE__*/ messageDesc(file_shopify_v1_graphql, 0);

/**
 * @generated from message shopify.v1.UserError
 */
export type UserError = Message<'shopify.v1.UserError'> & {
    /**
     * @generated from field: repeated string field = 1;
     */
    field: string[];

    /**
     * @generated from field: string message = 2;
     */
    message: string;
};

/**
 * Describes the message shopify.v1.UserError.
 * Use `create(UserErrorSchema)` to create a new message.
 */
export const UserErrorSchema: GenMessage<UserError> = /*@__PURE__*/ messageDesc(file_shopify_v1_graphql, 1);

/**
 * @generated from message shopify.v1.PageInfo
 */
export type PageInfo = Message<'shopify.v1.PageInfo'> & {
    /**
     * @generated from field: optional string start_cursor = 1;
     */
    startCursor?: string | undefined;

    /**
     * @generated from field: optional string end_cursor = 2;
     */
    endCursor?: string | undefined;

    /**
     * @generated from field: bool has_next_page = 3;
     */
    hasNextPage: boolean;

    /**
     * @generated from field: bool has_previous_page = 4;
     */
    hasPreviousPage: boolean;
};

/**
 * Describes the message shopify.v1.PageInfo.
 * Use `create(PageInfoSchema)` to create a new message.
 */
export const PageInfoSchema: GenMessage<PageInfo> = /*@__PURE__*/ messageDesc(file_shopify_v1_graphql, 2);

/**
 * @generated from message shopify.v1.Extensions
 */
export type Extensions = Message<'shopify.v1.Extensions'> & {
    /**
     * @generated from field: shopify.v1.Cost cost = 1;
     */
    cost?: Cost | undefined;
};

/**
 * Describes the message shopify.v1.Extensions.
 * Use `create(ExtensionsSchema)` to create a new message.
 */
export const ExtensionsSchema: GenMessage<Extensions> = /*@__PURE__*/ messageDesc(file_shopify_v1_graphql, 3);

/**
 * @generated from message shopify.v1.Cost
 */
export type Cost = Message<'shopify.v1.Cost'> & {
    /**
     * @generated from field: int64 requested_query_cost = 1;
     */
    requestedQueryCost: bigint;

    /**
     * @generated from field: int64 actual_query_cost = 2;
     */
    actualQueryCost: bigint;

    /**
     * @generated from field: shopify.v1.ThrottleStatus throttle_status = 3;
     */
    throttleStatus?: ThrottleStatus | undefined;
};

/**
 * Describes the message shopify.v1.Cost.
 * Use `create(CostSchema)` to create a new message.
 */
export const CostSchema: GenMessage<Cost> = /*@__PURE__*/ messageDesc(file_shopify_v1_graphql, 4);

/**
 * @generated from message shopify.v1.ThrottleStatus
 */
export type ThrottleStatus = Message<'shopify.v1.ThrottleStatus'> & {
    /**
     * @generated from field: double maximum_available = 1;
     */
    maximumAvailable: number;

    /**
     * @generated from field: int64 currently_available = 2;
     */
    currentlyAvailable: bigint;

    /**
     * @generated from field: double restore_rate = 3;
     */
    restoreRate: number;
};

/**
 * Describes the message shopify.v1.ThrottleStatus.
 * Use `create(ThrottleStatusSchema)` to create a new message.
 */
export const ThrottleStatusSchema: GenMessage<ThrottleStatus> = /*@__PURE__*/ messageDesc(file_shopify_v1_graphql, 5);
